import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { keys } from "./keys";
import { type CommunicationFilters, OTHER_ACTION_TYPE } from "./useGetCommunications";

async function getCommunicationsCount(filters: CommunicationFilters): Promise<number> {
  let query = apiClient
    .from('communications')
    .select('*', { count: 'exact', head: true });

  query = filters.kind === 'others'
    ? query.eq('type', OTHER_ACTION_TYPE)
    : query.neq('type', OTHER_ACTION_TYPE);

  if (filters.subjectId) {
    query = query.eq('subject_id', filters.subjectId);
  }

  if (filters.providerId) {
    query = query.eq('provider_id', filters.providerId);
  }

  const { count, error } = await query;

  if (error) {
    throw error;
  }

  return count ?? 0;
}

export function useGetCommunicationsCount(filters: CommunicationFilters) {
  const isEnabled = Boolean(filters.subjectId || filters.providerId);

  return useQuery({
    queryKey: [...keys.communications(filters), 'count'],
    queryFn: () => getCommunicationsCount(filters),
    enabled: isEnabled,
    staleTime: _3_DAYS,
  });
}
